const SVG_ICONS = (name, color, width = "14.5vw", height = "14.5vw") => {
  switch (name) {
    case "total-violation":
      return (
        <svg
          width={`${width}`}
          height={`${height}`}
          viewBox="0 0 62 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_347_24)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M53.0191 18.3964L50.5565 13.0366L41.72 8.98047L32.8835 13.0366L30.4209 18.3964L33.6078 21.5833C33.463 22.1627 33.463 22.7422 33.463 23.4665C33.463 27.9572 37.0845 31.7235 41.72 31.7235C46.2107 31.7235 49.977 28.102 49.977 23.4665C49.977 22.887 49.977 22.3076 49.8322 21.5833L53.164 18.2515L53.0191 18.3964Z"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M34.4771 20.4236C34.1874 20.7133 33.8976 20.7133 33.6079 20.4236C33.3182 20.1339 33.3182 19.8441 33.6079 19.5544C35.3462 17.961 38.3883 17.0918 41.5752 17.0918C44.7621 17.0918 47.9491 17.8161 49.8323 19.4096C50.122 19.6993 50.122 19.989 49.9771 20.2787C49.6874 20.5684 49.3977 20.5684 49.108 20.4236C47.3696 18.975 44.4724 18.3955 41.7201 18.3955C38.8229 18.3955 36.0705 19.1198 34.6219 20.4236H34.4771Z"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M41.5756 11.4434L40.9962 11.8779L40.2719 13.3265H38.3887L40.8513 15.0649H42.2999L44.7625 13.3265H42.8793L42.155 11.8779L41.5756 11.4434Z"
              fill={`${color}`}
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M45.4867 53.0184C47.225 53.0184 48.9633 52.2941 50.2671 50.9904C51.5708 49.6866 52.2951 47.9483 52.2951 46.21V36.2146C52.2951 35.6352 52.2951 35.2006 52.1502 34.6212L34.767 52.0044C35.781 52.5838 36.9399 52.8736 38.0988 52.8736H45.6315L45.4867 53.0184ZM50.8465 32.3034C50.5568 31.8688 50.1222 31.4343 49.6876 31.1445C47.6596 33.3174 44.7624 34.4763 41.7203 34.4763C38.6782 34.4763 35.9259 33.3174 33.753 31.1445C32.1595 32.4483 31.1455 34.3315 31.1455 36.5044V46.4997C31.1455 47.9483 31.5801 49.3969 32.5941 50.7007L50.7016 32.5931L50.8465 32.3034Z"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.4955 21.873H9.27117C9.11116 21.873 8.98145 22.0028 8.98145 22.1628V27.9572C8.98145 28.1172 9.11116 28.2469 9.27117 28.2469H25.4955C25.6555 28.2469 25.7852 28.1172 25.7852 27.9572V22.1628C25.7852 22.0028 25.6555 21.873 25.4955 21.873Z"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.1357 23.6113H24.3367"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.9492 23.6113H18.8324"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.4717 23.6113H14.6306"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.0332 25.0605H24.3369"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.3555 25.0605H18.8321"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21.4395 26.5078H24.3367"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.5146 26.5078H18.8324"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.4297 26.5078H14.6306"
              stroke={`${color}`}
              stroke-width="0.869161"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_347_24">
              <rect width="62.0002" height="62.0002" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "detailing-violation":
      return (
        <svg
          width={`${width}`}
          height={`${height}`}
          viewBox="0 0 62 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_346_2)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M53.077 18.4618L50.6155 13.0772L41.6924 9.07715L32.7693 13.0772L30.3077 18.4618L33.5385 21.6926C33.3847 22.308 33.3847 22.9233 33.3847 23.5387C33.3847 28.1541 37.077 31.8464 41.6924 31.8464C46.3078 31.8464 50.0001 28.1541 50.0001 23.5387C50.0001 22.9233 50.0001 22.308 49.8463 21.6926L53.077 18.4618Z"
              stroke={`${color}`}
              stroke-width="0.923079"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M34.4616 20.4618C34.1539 20.7695 33.8462 20.7695 33.5385 20.4618C33.2308 20.1541 33.2308 19.8464 33.5385 19.5387C35.2308 18.0002 38.3078 17.0771 41.5385 17.0771C44.6155 17.0771 47.8462 17.8464 49.8462 19.5387C50.1539 19.6925 50.1539 20.1541 50.0001 20.4618C49.8462 20.7695 49.3847 20.7695 49.077 20.6156C47.3847 19.231 44.4616 18.4618 41.6924 18.4618C38.7693 18.4618 36.0001 19.231 34.6154 20.4618H34.4616Z"
              stroke={`${color}`}
              stroke-width="0.923079"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M41.5385 11.3848L41.0769 11.8463L40.3077 13.3848H38.4615L40.7692 15.0771H42.3077L44.7693 13.3848H42.9231L42.1539 11.8463L41.5385 11.3848Z"
              fill={`${color}`}
              stroke={`${color}`}
              stroke-width="0.923079"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M45.5385 53.0772C47.3847 53.0772 49.077 52.308 50.3078 51.0772C51.5385 49.8464 52.3078 48.1541 52.3078 46.308V36.3079C52.3078 35.8464 52.3078 35.231 52.1539 34.7695L34.7693 52.1541C35.6923 52.7695 36.9231 53.0772 38 53.0772H45.5385ZM50.9232 32.3079C50.6155 31.8464 50.1539 31.3848 49.6924 31.0771C47.6924 33.231 44.7693 34.4618 41.8462 34.4618C38.9231 34.4618 36 33.231 34 31.0771C32.3077 32.3079 31.3846 34.3079 31.3846 36.3079V46.308C31.3846 47.8464 31.8462 49.231 32.7693 50.4618L50.9232 32.3079Z"
              stroke={`${color}`}
              stroke-width="0.923079"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.8462 25.0771H20.7693"
              stroke={`${color}`}
              stroke-width="0.769233"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.6154 25.3849C22.7854 25.3849 22.9231 25.2472 22.9231 25.0772C22.9231 24.9073 22.7854 24.7695 22.6154 24.7695C22.4455 24.7695 22.3077 24.9073 22.3077 25.0772C22.3077 25.2472 22.4455 25.3849 22.6154 25.3849Z"
              stroke={`${color}`}
              stroke-width="0.769233"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.8462 28.1543C14.7693 28.1543 17.6924 28.1543 20.6154 28.1543"
              stroke={`${color}`}
              stroke-width="0.769233"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.8462 31.0771C14.7693 31.0771 17.6924 31.0771 20.6154 31.0771"
              stroke={`${color}`}
              stroke-width="0.769233"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.8462 34H20.7693"
              stroke={`${color}`}
              stroke-width="0.769233"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.6154 27.6924C22.7693 27.6924 22.9231 27.8462 22.9231 28.0001C22.9231 28.1539 22.7693 28.3078 22.6154 28.3078C22.4616 28.3078 22.3077 28.1539 22.3077 28.0001C22.3077 27.8462 22.4616 27.6924 22.6154 27.6924Z"
              stroke={`${color}`}
              stroke-width="0.769233"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.6154 30.7695C22.7693 30.7695 22.9231 30.9234 22.9231 31.0772C22.9231 31.2311 22.7693 31.3849 22.6154 31.3849C22.4616 31.3849 22.3077 31.2311 22.3077 31.0772C22.3077 30.9234 22.4616 30.7695 22.6154 30.7695Z"
              stroke={`${color}`}
              stroke-width="0.769233"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.6154 34.3078C22.7854 34.3078 22.9231 34.17 22.9231 34.0001C22.9231 33.8301 22.7854 33.6924 22.6154 33.6924C22.4455 33.6924 22.3077 33.8301 22.3077 34.0001C22.3077 34.17 22.4455 34.3078 22.6154 34.3078Z"
              stroke={`${color}`}
              stroke-width="0.769233"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.6923 22H9.23075C9.14578 22 9.0769 22.3444 9.0769 22.7692V36.4616C9.0769 36.8864 9.14578 37.2308 9.23075 37.2308H25.6923C25.7773 37.2308 25.8462 36.8864 25.8462 36.4616V22.7692C25.8462 22.3444 25.7773 22 25.6923 22Z"
              stroke={`${color}`}
              stroke-width="0.769233"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_346_2">
              <rect width="62.0002" height="62.0002" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "pay-bill":
      return (
        <svg
          width={`${width}`}
          height={`${height}`}
          viewBox="0 0 63 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_0_1)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M52.956 18.3808L50.4759 12.9832L41.5771 8.89844L32.6782 12.9832L30.1982 18.3808L33.4077 21.5902C33.2618 22.1738 33.2618 22.7573 33.2618 23.4867C33.2618 28.0091 36.9088 31.6561 41.4312 31.6561C45.9536 31.6561 49.6006 28.0091 49.6006 23.4867C49.6006 22.9032 49.6006 22.3196 49.4548 21.7361L52.8101 18.3808H52.956Z"
              stroke={`${color}`}
              stroke-width="0.875296"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M34.4291 20.4237C34.1373 20.7154 33.8456 20.7154 33.5538 20.4237C33.262 20.1319 33.262 19.8401 33.5538 19.5484C35.1585 17.9437 38.3679 17.0684 41.5773 17.0684C44.6409 17.0684 47.8503 17.7978 49.8927 19.4025C50.1844 19.6942 50.1844 19.986 50.0385 20.2778C49.7468 20.5695 49.455 20.5695 49.1632 20.4237C47.4126 18.9648 44.6409 18.3813 41.7232 18.3813C38.8056 18.3813 36.0338 19.1107 34.575 20.4237H34.4291Z"
              stroke={`${color}`}
              stroke-width="0.875296"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M41.5776 11.3789L40.9941 11.8166L40.2646 13.4213H38.3682L40.8482 15.026H42.307L44.787 13.4213H42.8905L42.1611 11.8166L41.5776 11.3789Z"
              fill={`${color}`}
              stroke={`${color}`}
              stroke-width="0.875296"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M45.5159 52.9547C47.2664 52.9547 49.017 52.2253 50.33 50.9123C51.6429 49.5994 52.2265 47.9947 52.2265 46.0982V36.1782C52.2265 35.5946 52.2265 35.157 52.0806 34.5734L34.7205 51.9335C35.7417 52.517 36.9088 52.8088 38.0758 52.8088H45.5159V52.9547ZM50.9135 32.2393C50.6218 31.8017 50.1841 31.364 49.7465 31.0723C47.7041 33.2605 44.7864 34.4276 41.8688 34.4276C38.9511 34.4276 36.0335 33.2605 33.9911 31.0723C32.3864 32.3852 31.3652 34.2817 31.3652 36.324V46.2441C31.3652 47.7029 31.8029 49.1617 32.8241 50.3288L50.9135 32.2393Z"
              stroke={`${color}`}
              stroke-width="0.875296"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.5297 21.8828H9.33669C9.17555 21.8828 9.04492 22.0134 9.04492 22.1746V27.864C9.04492 28.0251 9.17555 28.1558 9.33669 28.1558H25.5297C25.6908 28.1558 25.8214 28.0251 25.8214 27.864V22.1746C25.8214 22.0134 25.6908 21.8828 25.5297 21.8828Z"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.1318 23.6328H24.3624"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.9229 23.6328H18.8193"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.4219 23.6328H14.5889"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.0498 25.0918H24.3627"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.3184 25.0918H18.8195"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21.4453 26.5508H24.363"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.4854 26.5508H18.8195"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.3574 26.5508H14.588"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.04492 35.0117H11.9626C11.9626 39.8258 11.9626 44.64 11.9626 49.4541H9.04492V35.0117ZM14.1508 35.0117H19.5485C20.7155 35.0117 21.7367 35.1576 22.3202 35.3035C23.1955 35.5952 23.925 36.0329 24.5085 36.6164C25.092 37.2 25.5297 38.0753 25.8214 38.9506C26.1132 39.8258 26.2591 40.9929 26.2591 42.3059C26.2591 43.4729 26.1132 44.4941 25.8214 45.3694C25.5297 46.3906 24.9461 47.2659 24.2167 47.9953C23.7791 48.4329 23.0497 48.8706 22.1744 49.1623C21.5908 49.3082 20.7155 49.4541 19.5485 49.4541H14.0049V35.0117H14.1508ZM17.0685 37.4917V47.12H19.2567C20.132 47.12 20.7155 47.12 21.0073 46.9741C21.445 46.8282 21.8826 46.6823 22.1744 46.3906C22.4661 46.0988 22.7579 45.6612 22.9038 44.9317C23.0497 44.3482 23.1955 43.327 23.1955 42.3059C23.1955 41.1388 23.0497 40.2635 22.9038 39.68C22.7579 39.0964 22.4661 38.6588 22.0285 38.2211C21.7367 37.9294 21.1532 37.6376 20.7155 37.4917C20.2779 37.3458 19.5485 37.3458 18.3814 37.3458H17.0685V37.4917Z"
              stroke={`${color}`}
              stroke-width="0.729414"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_0_1">
              <rect width="62.0002" height="62.0009" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "certificate-inquiry":
      return (
        <svg
          width={`${width}`}
          height={`${height}`}
          viewBox="0 0 62 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M51.9963 9.16992H9.89875C9.38081 9.16992 8.96094 10.1963 8.96094 11.4624V36.6792C8.96094 37.9453 9.38081 38.9717 9.89875 38.9717H51.9963C52.5143 38.9717 52.9342 37.9453 52.9342 36.6792V11.4624C52.9342 10.1963 52.5143 9.16992 51.9963 9.16992Z"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.8799 22.2988H28.6547"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.8164 26.7793C17.7139 26.7793 22.7156 26.7793 27.6131 26.7793"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.9639 31.3652C23.8614 31.3652 23.653 31.3652 28.6546 31.3652"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.7959 35.8457H26.5707"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M30.7393 22.2988H34.6989"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.6973 26.7793C31.3645 26.7793 33.0317 26.7793 34.699 26.7793"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M30.7393 31.3652C32.4065 31.3652 33.0317 31.3652 34.6989 31.3652"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M28.7598 35.8457H34.6993"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M38.6582 31.365V28.5516C38.6582 27.4054 39.1792 26.2591 40.0128 25.5297C41.159 26.7802 42.6179 27.4054 44.2851 27.4054C45.8481 27.4054 47.4112 26.6759 48.5574 25.5297C49.391 26.2591 49.912 27.4054 49.912 28.5516V31.365H38.6582ZM48.7658 21.2574C48.7658 18.6524 46.786 16.5684 44.2851 16.5684C41.7843 16.5684 39.8044 18.6524 39.8044 21.2574C39.8044 23.8625 41.7843 25.9465 44.2851 25.9465C46.786 25.9465 48.7658 23.8625 48.7658 21.2574Z"
            stroke={`${color}`}
            stroke-width="0.937818"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M27.7174 15.7346C27.1964 15.7346 26.8838 15.3178 26.8838 14.7968C26.8838 14.2758 27.3006 13.859 27.7174 13.859H29.9056C30.114 13.338 30.5309 13.0254 31.0519 13.0254C31.5729 13.0254 31.9897 13.338 32.1981 13.859H34.3863C34.9073 13.859 35.2199 14.2758 35.2199 14.7968C35.2199 15.3178 34.8031 15.7346 34.3863 15.7346H32.1981C31.9897 16.2557 31.5729 16.5683 31.0519 16.5683C30.5309 16.5683 30.114 16.2557 29.9056 15.7346H27.7174Z"
            fill={`${color}`}
            stroke={`${color}`}
            stroke-width="0.625212"
            stroke-miterlimit="2.61313"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.6738 8.96094L26.2587 13.8584C27.1965 14.7962 27.8218 15.6299 28.2386 16.1509C28.6554 16.6719 28.8638 17.2971 28.968 17.9223C29.0722 18.5475 29.0722 19.1727 28.8638 19.9021C28.6554 20.5274 28.3428 21.1526 27.8218 21.6736C27.3007 22.1946 26.6755 22.6114 25.9461 22.8198C25.2167 23.0282 24.4873 22.924 23.7579 22.6114C24.2789 23.5492 24.4873 24.487 24.2789 25.4248C24.1747 26.3627 23.7579 27.1963 23.1327 27.8215C22.6117 28.3425 21.9864 28.7593 21.257 29.0719C20.5276 29.3845 19.7982 29.3845 19.0688 29.2803C18.3394 29.1761 17.61 28.7593 16.9847 28.2383C16.5679 27.8215 15.6301 26.8837 14.0671 25.3206L10.1074 21.1526L21.6738 8.96094ZM22.0906 13.4416L19.3814 16.2551L20.9444 17.8181C21.8822 18.7559 22.4033 19.3811 22.7159 19.5895C23.1327 20.0063 23.6537 20.1105 24.0705 20.1105C24.4873 20.1105 24.9041 19.9021 25.3209 19.4853C25.6335 19.0685 25.8419 18.6517 25.8419 18.2349C25.8419 17.8181 25.7377 17.2971 25.3209 16.8803C25.1125 16.5677 24.4873 15.9425 23.3411 14.692L21.9864 13.2332L22.0906 13.4416ZM17.5058 18.2349L14.3797 21.4652L16.5679 23.7576C17.4016 24.5912 17.9226 25.2164 18.2352 25.3206C18.652 25.6332 19.0688 25.7375 19.5898 25.7375C20.0066 25.7375 20.5276 25.529 20.9444 25.008C21.257 24.5912 21.4654 24.2786 21.5696 23.8618C21.6738 23.445 21.5696 23.0282 21.3612 22.5072C21.1528 22.0904 20.5276 21.2568 19.4856 20.1105L17.61 18.1307L17.5058 18.2349ZM32.1982 44.2854L29.6974 41.6803L31.3646 37.8249L26.7797 32.9274L23.2369 34.6988L20.736 32.0938L36.7831 24.6954L39.284 27.3005L32.4066 44.2854H32.1982ZM32.5108 35.0114L35.2201 28.8635L29.3848 31.677L32.5108 35.0114ZM45.0151 33.4484L49.2874 37.9291C50.2252 38.9711 50.9546 39.8047 51.2672 40.4299C51.7882 41.3677 51.9966 42.3056 51.8924 43.3476C51.8924 44.3896 51.5798 45.4316 51.163 46.4736C50.642 47.5157 49.9126 48.5577 48.7663 49.7039C47.8285 50.7459 46.8907 51.4753 45.9529 51.8921C44.8067 52.5173 43.7646 52.7258 42.7226 52.7258C41.889 52.7258 41.0554 52.4131 40.2218 51.9963C39.5966 51.5795 38.763 50.9543 37.9293 50.1207L33.5529 45.5358L45.1193 33.3442L45.0151 33.4484ZM45.4319 37.9291L37.8251 45.9526L39.5966 47.8283C40.2218 48.5577 40.7428 48.9745 41.1596 49.1829C41.6806 49.4955 42.0974 49.5997 42.6184 49.7039C43.1394 49.7039 43.6604 49.5997 44.2857 49.1829C44.9109 48.7661 45.7445 48.1409 46.6823 47.2031C47.6201 46.2652 48.1411 45.4316 48.4537 44.8064C48.7663 44.1812 48.9747 43.556 48.8705 42.9308C48.8705 42.3056 48.6621 41.7845 48.3495 41.2635C48.1411 40.8467 47.5159 40.1173 46.5781 39.1795L45.5361 38.0333L45.4319 37.9291Z"
            fill={`${color}`}
            fill-opacity="0.501961"
          />
        </svg>
      );

    case "insurance-inquiry":
      return (
        <svg
          width={`${width}`}
          height={`${height}`}
          viewBox="0 0 62 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_349_62)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.286 22.373C31.3901 25.1558 26.0472 25.1558 22.1513 22.373C18.2554 25.1558 12.9125 25.1558 9.0166 22.373V35.1738C9.0166 38.9584 10.6863 42.7429 13.1351 45.8596C15.4726 48.9763 18.5893 51.5365 22.1513 52.8722C25.7132 51.5365 28.8299 48.9763 31.1675 45.8596C33.505 42.7429 35.286 38.9584 35.286 35.1738V22.373ZM22.1513 50.0895C21.5947 49.8668 21.1495 49.5329 20.7042 49.3103C19.8138 48.7537 18.9233 48.0859 18.1441 47.3067C17.2536 46.5275 16.5857 45.7483 15.8066 44.8578C15.4726 44.4126 15.1387 43.9674 14.8048 43.5221C14.4708 43.0769 14.1369 42.5203 13.9143 42.0751C13.469 41.1846 13.0238 40.2941 12.5785 39.4036C12.3559 38.9584 12.2446 38.4018 12.1333 37.9566C11.9107 37.0661 11.7994 36.0643 11.7994 35.0625V26.8255C15.3613 27.6047 19.0346 27.1594 22.2626 25.4898C25.4906 27.0481 29.1639 27.6047 32.7258 26.8255V35.0625C32.7258 36.0643 32.6145 36.9548 32.3919 37.9566C32.2806 38.4018 32.058 38.9584 31.9466 39.4036C31.6127 40.2941 31.1675 41.1846 30.6109 42.0751C30.277 42.5203 30.0544 43.0769 29.7204 43.5221C29.3865 43.9674 29.0526 44.4126 28.7186 44.8578C28.0508 45.7483 27.2716 46.5275 26.3811 47.3067C25.6019 48.0859 24.7114 48.7537 23.821 49.3103C23.3757 49.6442 22.8192 49.8668 22.3739 50.0895H22.1513ZM27.049 32.0571L20.0364 38.7357L16.9197 35.7304C16.8084 35.619 16.5857 35.5077 16.4744 35.5077C16.2518 35.5077 16.1405 35.619 16.0292 35.7304C15.9179 35.8417 15.8066 36.0643 15.8066 36.1756C15.8066 36.3982 15.9179 36.5095 16.0292 36.6208L20.1477 40.628L28.1621 32.9476C28.3847 32.725 28.496 32.2797 28.1621 31.9458C28.0508 31.8345 27.8281 31.7232 27.7168 31.7232C27.4942 31.7232 27.3829 31.8345 27.2716 31.9458L27.049 32.0571Z"
              stroke={`${color}`}
              stroke-width="0.445244"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M40.2953 30.1647C42.1875 27.9385 43.3007 25.0444 43.3007 21.9277C43.3007 14.8038 37.5125 9.01562 30.2773 9.01562C23.0421 9.01562 17.2539 14.8038 17.2539 21.9277C17.2539 29.0516 23.0421 34.8398 30.2773 34.8398C33.394 34.8398 36.2881 33.7266 38.5143 31.9457H38.6256L40.2953 33.6153C40.4066 33.1701 40.6292 32.8362 40.9631 32.5022C40.4066 31.9457 39.7387 31.2778 39.4048 30.9439L40.2953 30.0534L42.0762 31.8344L42.7441 34.1719C45.3043 36.732 49.3114 40.6279 50.5359 41.9636"
              stroke={`${color}`}
              stroke-width="0.890487"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M48.755 43.7437C49.7568 44.7455 51.3152 44.7455 52.2057 43.7437C53.2075 42.742 53.2075 41.2949 52.2057 40.2931L44.4139 32.5014C43.746 31.8335 42.8555 31.6109 42.0764 31.8335C41.1859 32.0561 40.518 32.724 40.2954 33.5031C40.0728 34.3936 40.2954 35.2841 40.9633 35.8407L48.755 43.6324V43.7437Z"
              stroke={`${color}`}
              stroke-width="0.890487"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M30.2765 33.5042C36.7314 33.5042 41.9642 28.3213 41.9642 21.9279C41.9642 15.5345 36.7314 10.3516 30.2765 10.3516C23.8216 10.3516 18.5889 15.5345 18.5889 21.9279C18.5889 28.3213 23.8216 33.5042 30.2765 33.5042Z"
              stroke={`${color}`}
              stroke-width="0.890487"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.2855 32.391C34.395 32.8363 33.5045 33.0589 32.6141 33.2815V26.8255C29.0521 27.6047 25.3788 27.1594 22.1508 25.4898C21.2603 25.935 20.4812 26.2689 19.4794 26.4916C19.1454 25.7124 18.9228 24.8219 18.7002 24.0427C19.9246 23.7088 21.0377 23.1522 22.0395 22.373C25.9354 25.1558 31.2783 25.1558 35.1742 22.373V32.2797L35.2855 32.391ZM27.8277 33.2815C27.2711 33.1702 26.8259 33.0589 26.2693 32.8363L26.9372 32.1684C27.0485 32.0571 27.2711 31.9458 27.3824 31.9458C27.6051 31.9458 27.7164 32.0571 27.8277 32.1684C28.0503 32.391 28.0503 32.8363 27.8277 33.1702L27.7164 33.2815H27.8277Z"
              stroke={`${color}`}
              stroke-width="1.44704"
              stroke-miterlimit="2.61313"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_349_62">
              <rect width="62.0002" height="62.0002" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
  }
};

export { SVG_ICONS };
